import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

export const Text = styled.div`
  max-width: 62ch;
  font-size: 14px;
  line-height: 1.6;
  color: ${({ theme }) => theme.text.workspaceItem};
`;

export const Alternatives = styled.div`
  display: flex;
  flex-direction: column;
  gap: 9px;
`;

export const AlternativesTitle = styled.span`
  font-size: 12.5px;
  font-weight: 600;
  color: ${({ theme }) => theme.text.actionBar};
`;

export const Chips = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const Chip = styled.button`
  padding: 6px 13px;
  border: 1px solid ${({ theme }) => theme.borders.workspaceItem};
  border-radius: 4px;
  background-color: ${({ theme }) => theme.backgrounds.modal};
  color: ${({ theme }) => theme.text.workspaceItem};
  font-size: 12.5px;
  cursor: pointer;

  &:hover {
    border-color: ${({ theme }) => theme.borders.workspaceSelectedItem};
    color: ${({ theme }) => theme.borders.workspaceSelectedItem};
  }
`;
